/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import clsx from "clsx";

import { API, graphqlOperation } from "aws-amplify";
import { inventoryItemByLocationByStatus } from "../../graphql/inventory/custom-queries";
import {
  getOutboundShipmentTimeline,
  searchOutboundShipments,
} from "../../graphql/outbound/custom-queries";
import {
  aisleByActiveByZoneBySortKey,
  areaByActiveBySortKey,
  locationByAisleBySortKey,
} from "../../graphql/reloadyard/custom-queries";
import { getLocation } from "../../graphql/queries";

import {
  alpha,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Hidden,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { blueGrey, deepOrange, green, grey } from "@material-ui/core/colors";

import {
  ArrayField,
  AutocompleteInput,
  Button,
  Datagrid,
  FunctionField,
  Loading,
  NumberField,
  required,
  SelectInput,
  TextField,
  TextInput,
  useNotify,
} from "react-admin";

import { logError, setupLocationMaps } from "../../utils/appUtils";
import {
  CarrierType,
  InventoryStatus,
  LocationLoadType,
  LocationType,
  OutboundStatus,
  OutboundStatusLabels,
} from "../../utils/constants";
import {
  filterAisles,
  filterAreas,
  filterZones,
  getAisleFullName,
  getLocationFullName,
  getLocationViewName,
  getZone,
  isBulkLocation,
  isBulkLocationAvailable,
  isCapacitySliderVisible,
  isLocationAvailable,
  isTrack,
  isTruckToRail,
} from "../../utils/locationUtils";
import { isShippingContainer } from "../../utils/loadTypeUtils";
import { InventoryStatusIcon } from "../../managerApp/resources/inventory/InventoryStatusIcon";
import { CancelIcon, CheckIcon, CloseIcon, ShowIcon } from "./iconography";
import { StructuredLocationCapacity } from "./LocationCapacity";
import SwitchOnOff from "./AntSwitch";
import { TrackLocationView } from "./TrackLocationView";
import {
  getSelectableOutbounds,
  getSelectedOutboundTrackId,
  getTrackDisplayLocationName,
  getTrackDisplaySelectedTrack,
  isOutboundUnavailable,
} from "./locationPickerTrackUtils";

const useStyles = makeStyles((theme) => ({
  locationAvatar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.getContrastText(green[600]),
    backgroundColor: green[600],
    borderColor: green[600],
    border: "5px solid",
    borderRadius: theme.spacing(0.5),
    margin: theme.spacing(0.5),
    paddingTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    whiteSpace: "nowrap",
    width: "100%",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: alpha(green[700], 0.8),
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
  },
  locationAvatarDisabled: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.getContrastText(
      theme.palette.type === "dark" ? grey[400] : grey[300],
    ),
    backgroundColor: theme.palette.type === "dark" ? grey[400] : grey[300],
    border: "5px solid",
    borderColor: theme.palette.type === "dark" ? grey[400] : grey[300],
    borderRadius: theme.spacing(0.5),
    margin: theme.spacing(0.5),
    paddingTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    whiteSpace: "nowrap",
    width: "100%",
  },
  locationAvatarSelected: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
    border: "5px solid",
    borderColor: theme.palette.getContrastText(deepOrange[500]),
    borderRadius: theme.spacing(0.5),
    margin: theme.spacing(0.5),
    paddingTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    whiteSpace: "nowrap",
    width: "100%",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: deepOrange[400],
      color: theme.palette.getContrastText(deepOrange[400]),
    },
  },
  locationAvatarOriginal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.getContrastText(theme.palette.background.default),
    backgroundColor: deepOrange[500],
    border: "5px solid",
    borderColor: grey[500],
    borderRadius: theme.spacing(0.5),
    margin: theme.spacing(0.5),
    paddingTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    whiteSpace: "nowrap",
    width: "100%",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: alpha(deepOrange[600], 0.5),
    },
  },
  locationAvatarAllocated: {
    border: "5px solid",
    borderColor: deepOrange[600],
    borderRadius: theme.spacing(0.5),
    "&:hover": {
      cursor: "pointer",
    },
  },
  location: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    padding: theme.spacing(1),
    minHeight: theme.spacing(8),
    marginLeft: theme.spacing(0.75),
  },
  bayContainer: {
    display: "flex",
    flexDirection: "column-reverse",
    alignItems: "center",
    alignContent: "space-between",
    border: "1px solid #b0bec5",
    borderRadius: theme.spacing(1),
    margin: theme.spacing(0.5),
    padding: theme.spacing(0.5),
    paddingTop: theme.spacing(1),
  },
  divider: {
    borderTop: "1px solid #b0bec5",
    marginTop: theme.spacing(1),
    width: "100%",
  },
  levelContainer: {
    border: "1px solid",
    borderColor: blueGrey[500],
    margin: theme.spacing(0.5),
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  switchInput: {
    marginRight: theme.spacing(1),
    minWidth: "8rem",
  },
  dialogTitle: {
    display: "flex",
    paddingTop: "5px",
    paddingBottom: "5px",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
  },
}));

const validateRequired = required();

export const getOutboundOptionText = (outboundShipment) => {
  if (isOutboundUnavailable(outboundShipment)) {
    return `\u140A\u140A ${outboundShipment.railCarNumber} - ${outboundShipment.accountName}`;
  }

  return `\u25C0\u25C0 ${outboundShipment.railCarNumber} - ${outboundShipment.accountName}`;
};

export const AreaZonePicker = ({
  areaLabel = "Area",
  zoneLabel = "Zone",
  inventory,
  inventoryItem,
  showOutbounds = false,
  handleLocation,
  disabled = false,
  ...props
}) => {
  const notify = useNotify();
  const [areas, setAreas] = useState(window.appUser.reloadYard?.areas.items);
  const [zones, setZones] = useState([]);

  useEffect(() => {
    getAreas();
  }, []);

  useEffect(() => {
    setupAreasZones(inventory, window.appUser.reloadYard?.areas.items);
  }, [inventory.reloadYardCommodityId]);

  const getAreas = async () => {
    try {
      debugger;
      const areaRsponse = await API.graphql(
        graphqlOperation(areaByActiveBySortKey, {
          reloadYardId: window.appUser?.reloadYardId,
          activeSortKey: { beginsWith: { active: "true" } },
          limit: 1000,
        }),
      );
      const areas = areaRsponse.data.areaByActiveBySortKey.items;
      window.appUser.reloadYard.areas.items = areas;
      setupLocationMaps(window.appUser.reloadYard);

      setupAreasZones(inventory, areas);
    } catch (err) {
      logError("LocationPicker:getAreas", err, notify);
    }
  };

  const setupAreasZones = (inventory, areas) => {
    try {
      debugger;
      let areaId =
        inventoryItem?.location?.areaId ||
        inventoryItem?.areaId ||
        inventory.areaId;
      let zoneId =
        inventoryItem?.location?.zoneId ||
        inventoryItem?.zoneId ||
        inventory.zoneId;

      const filteredAreas = filterAreas(areas, inventory.reloadYardCommodityId);
      setAreas(filteredAreas);

      if (filteredAreas.length === 1) {
        areaId = filteredAreas[0].id;
        handleAreaChange(areaId);
      } else {
        let area = filteredAreas.find((areaRecord) => areaRecord.id === areaId);
        let zone = null;

        if (area) {
          area.zones = { ...area.zones };
          const filteredZones = filterZones(
            area.zones.items,
            inventory.reloadYardCommodityId,
            inventory.accountId,
          );
          setZones(filteredZones);

          if (filteredZones.length === 1) {
            zone = filteredZones[0];
          } else {
            zone = filteredZones.find((zoneRecord) => zoneRecord.id === zoneId);
          }
        }
        handleLocation && handleLocation(area, zone);
      }
    } catch (err) {
      logError("LocationPicker:setupAreasZones", err, notify);
    }
  };

  const handleAreaChange = (areaId) => {
    debugger;
    if (areaId) {
      const area = areas.find((areaRecord) => areaRecord.id === areaId);
      const filteredZones = filterZones(
        area.zones.items,
        inventory.reloadYardCommodityId,
        inventory.accountId,
      );
      setZones(filteredZones);
      const zone = filteredZones.length === 1 ? filteredZones[0] : null;
      handleLocation(area, zone);
    }
  };

  const handleZoneChange = (zoneId) => {
    debugger;
    if (zoneId) {
      let area =
        inventoryItem?.location?.area || inventoryItem?.area || inventory.area;
      if (!area) {
        const areaId =
          inventoryItem?.location?.areaId ||
          inventoryItem?.areaId ||
          inventory.areaId;
        area = areas.find((areaRecord) => areaRecord.id === areaId);
      }
      const zone = zones.find((zoneRecord) => zoneRecord.id === zoneId);
      handleLocation(area, zone);
    } else {
      // When cleared, propagate null so parent can reset aisle/locations
      let area =
        inventoryItem?.location?.area || inventoryItem?.area || inventory.area;
      if (!area) {
        const areaId =
          inventoryItem?.location?.areaId ||
          inventoryItem?.areaId ||
          inventory.areaId;
        area = areas.find((areaRecord) => areaRecord.id === areaId);
      }
      handleLocation(area, null);
    }
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <SelectInput
          source="areaId"
          label={areaLabel}
          variant="outlined"
          fullWidth
          disabled={disabled}
          allowEmpty={false}
          choices={areas}
          optionText="name"
          optionValue="id"
          validate={validateRequired}
          onChange={(e) => handleAreaChange(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectInput
          source="zoneId"
          label={zoneLabel}
          variant="outlined"
          fullWidth
          disabled={disabled || showOutbounds}
          choices={zones}
          optionText="name"
          optionValue="id"
          allowEmpty={!inventory?.account?.requireDefaultZone}
          validate={
            inventory?.account?.requireDefaultZone
              ? validateRequired
              : undefined
          }
          onChange={(e) => handleZoneChange(e.target.value)}
        />
      </Grid>
    </Grid>
  );
};

const getOutbound = async (outboundShipmentId, setOutbound, notify) => {
  try {
    debugger;
    const input = { id: outboundShipmentId };
    const response = await API.graphql(
      graphqlOperation(getOutboundShipmentTimeline, input),
    );
    const outboundShipment = response.data.getOutboundShipment;
    setOutbound(outboundShipment);
  } catch (err) {
    logError("OutboundPicker:getOutbound", err, notify);
  }
};

export const LocationPicker = ({
  inventory,
  inventoryItem,
  originalLocation,
  handleLocation,
  selectedLocation,
  locationInventoryItemMap = {}, // for EDIT - location is locked
  bayList,
  setBayList,
  isMaxQuantity,
  disabled = false,
  required = false,
  ...props
}) => {
  const classes = useStyles();
  const notify = useNotify();
  const [aisles, setAisles] = useState([]);
  const [selectedAisle, setSelectedAisle] = useState(
    inventoryItem.aisle || inventoryItem.location?.aisle,
  );
  const [locationName, setLocationName] = useState("");
  const [outbound, setOutbound] = useState();
  const area = inventoryItem?.area || inventoryItem?.location?.area; // getArea(inventoryItem.areaId);
  const zone =
    inventoryItem?.zone ||
    inventoryItem?.location?.zone ||
    getZone(area, inventoryItem?.zoneId);
  const [showOutbounds, setShowOutbounds] = useState(
    isTruckToRail(area, inventory.inboundShipment),
  );

  useEffect(() => {
    if (inventoryItem.areaId) {
      setShowOutbounds(isTruckToRail(area, inventory.inboundShipment));
    }
  }, [inventoryItem.areaId]);

  useEffect(() => {
    debugger;
    if (inventoryItem.zoneId?.trim()) {
      getAisles();
    } else setAisles([]);
  }, [inventoryItem.zoneId]);

  useEffect(() => {
    debugger;
    if (inventoryItem.location) {
      setLocationName(getLocationFullName(inventoryItem.location));
    }
  }, [inventoryItem.location]);

  // useEffect(() => {
  //     debugger;
  //     if (inventoryItem.outboundShipment) {
  //         setOutbound(inventoryItem.outboundShipment);
  //     }
  // }, [inventoryItem.outboundShipment]);

  useEffect(() => {
    debugger;
    if (inventoryItem.outboundShipmentId && !outbound) {
      getOutbound(inventoryItem.outboundShipmentId, setOutbound, notify);
    }
  }, [inventoryItem.outboundShipmentId]);

  useEffect(() => {
    debugger;
    if (!selectedAisle) setBayList([]);
    if (
      selectedAisle?.type === LocationType.STRUCTURED ||
      isBulkLocation(selectedAisle)
    ) {
      setupStructuredAisle();
    }
  }, [selectedAisle]);

  const getAisles = async () => {
    try {
      debugger;
      const zoneId = inventoryItem.zoneId?.trim();
      if (!zoneId) {
        setAisles([]);
        return [];
      }
      const response = await API.graphql(
        graphqlOperation(aisleByActiveByZoneBySortKey, {
          zoneId,
          activeSortKey: { beginsWith: { active: "true" } },
          limit: 1000,
        }),
      );
      const aisles = filterAisles(
        response.data.aisleByActiveByZoneBySortKey.items,
        inventoryItem.inventory,
      );
      setAisles(aisles);

      if (aisles?.length > 0) {
        if (showOutbounds) {
          if (!inventoryItem?.outboundShipmentId) {
            setSelectedAisle(null);
          }
        }
      } else setSelectedAisle(null);
    } catch (err) {
      logError("LocationPicker:setSelectedValues", err, notify);
    }
  };

  const setupStructuredAisle = async () => {
    if (!selectedAisle?.id) return;
    try {
      const response = await API.graphql(
        graphqlOperation(locationByAisleBySortKey, {
          aisleId: selectedAisle.id,
          limit: 1000,
        }),
      );
      const filteredLocations =
        response.data.locationByAisleBySortKey.items.filter(
          (locationRecord) => locationRecord.active === "true",
        );
      const bayList = [];
      debugger;

      for (let location of filteredLocations) {
        const allocatedInventoryItems = locationInventoryItemMap[location.id];
        if (allocatedInventoryItems && allocatedInventoryItems[0]) {
          location = allocatedInventoryItems[0].location;
        }

        const bay = location.bay;
        if (!bayList[bay]) bayList[bay] = [];
        const level = location.level;
        if (!bayList[bay][level - 1]) bayList[bay][level - 1] = [];
        bayList[bay][level - 1].push(location);
      }
      bayList.splice(0, 1);
      for (let bay of bayList) {
        if (!bay || bay.length === 0) continue;
        for (let level of bay) {
          level.sort((a, b) => {
            return a.position - b.position;
          });
        }
      }
      setBayList(bayList);
    } catch (err) {
      logError("LocationPicker:StructuredPickerDialog:setupAisle", err, notify);
    }
  };

  const getLocationPicker = () => {
    if (showOutbounds) {
      // inbound area = TRACK && carrierType = TRUCK.
      // inbound TRUCK inventory loaded into a receiving railcar
      // Select a receiving railcar, no matter what track it is on.
      return (
        <OutboundSelector
          {...props}
          inventory={inventory}
          inventoryItem={inventoryItem}
          selectedArea={area}
          selectedZone={zone}
          aisles={aisles}
          selectedAisle={selectedAisle}
          setSelectedAisle={setSelectedAisle}
          selectedLocation={selectedLocation}
          locationName={locationName}
          setLocationName={setLocationName}
          handleLocation={handleLocation}
          outbound={outbound}
          setOutbound={setOutbound}
          disabled={disabled}
          required={required}
        />
      );
    }

    // STRUCTURED, UNSTRUCTURED aisle & TRACK picker
    return (
      <AislePicker
        {...props}
        inventory={inventory}
        inventoryItem={inventoryItem}
        selectedArea={area}
        aisles={aisles}
        selectedAisle={selectedAisle}
        setSelectedAisle={setSelectedAisle}
        originalLocation={originalLocation}
        selectedLocation={selectedLocation}
        outbound={outbound}
        showOutbounds={showOutbounds}
        handleLocation={handleLocation}
        disabled={disabled || !zone}
        required={required}
        classes={classes}
      />
    );
  };

  const getLocationSelector = () => {
    if (selectedAisle && isTrack(area)) {
      debugger;
      return (
        <TrackDisplay
          classes={classes}
          inventoryItem={inventoryItem}
          outbound={outbound}
          selectedLocation={selectedLocation}
          locationName={locationName}
        />
      );
    }

    if (selectedAisle && isBulkLocation(selectedAisle)) {
      // Dry + Liquid Bulk
      return (
        <BulkSelector
          {...props}
          classes={classes}
          inventoryItem={inventoryItem}
          inventory={inventory}
          isMaxQuantity={isMaxQuantity}
          originalLocation={originalLocation}
          selectedLocation={selectedLocation}
          handleLocation={handleLocation}
          bayList={bayList}
          locationInventoryItemMap={locationInventoryItemMap}
          notify={notify}
        />
      );
    }

    if (selectedAisle?.type === LocationType.STRUCTURED) {
      return (
        <StructuredLocationSelector
          classes={classes}
          inventoryItem={inventoryItem}
          inventory={inventory}
          isMaxQuantity={isMaxQuantity}
          originalLocation={originalLocation}
          selectedLocation={selectedLocation}
          handleLocation={handleLocation}
          bayList={bayList}
          locationInventoryItemMap={locationInventoryItemMap}
          notify={notify}
        />
      );
    }
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <AreaZonePicker
          {...props}
          inventory={inventory}
          inventoryItem={inventoryItem}
          showOutbounds={showOutbounds}
          handleLocation={handleLocation}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        {getLocationPicker()}
      </Grid>
      <Grid item xs={12}>
        {getLocationSelector()}
      </Grid>
    </Grid>
  );
};

const AislePicker = ({
  inventory,
  inventoryItem,
  selectedArea,
  aisles,
  selectedAisle,
  setSelectedAisle,
  originalLocation,
  selectedLocation,
  handleLocation,
  outbound,
  showOutbounds,
  disabled,
  required,
  classes,
  ...props
}) => {
  const notify = useNotify();

  useEffect(() => {
    debugger;
    if (aisles?.length > 0) {
      const aisle =
        aisles.length === 1
          ? aisles[0]
          : aisles.find(
              (candidateAisle) => candidateAisle.id === inventoryItem.aisleId,
            );
      handleAisleChange(aisle?.id);
    }
  }, [aisles]);

  const handleAisleChange = async (aisleId) => {
    debugger;
    try {
      let location = null;
      let aisle = null;

      if (aisleId) {
        aisle = aisles.find((candidateAisle) => candidateAisle.id === aisleId);
        setSelectedAisle(aisle);
        if (aisle?.type === LocationType.UNSTRUCTURED) {
          const response = await API.graphql(
            graphqlOperation(locationByAisleBySortKey, { aisleId: aisle.id }),
          );
          const locations = response.data.locationByAisleBySortKey.items.filter(
            (locationRecord) => locationRecord.active === "true",
          );

          location = locations[0];
          handleLocation(
            inventoryItem.area,
            inventoryItem.zone,
            aisle,
            location,
            null,
          );
        } else {
          if (
            aisleId !== originalLocation?.aisleId ||
            inventoryItem?.locationId !== originalLocation?.id
          ) {
            // location has changed - not an initial load
            handleLocation(
              inventoryItem.area,
              inventoryItem.zone,
              aisle,
              null,
              null,
            );
          }
        }
      } else {
        setSelectedAisle(null);
        handleLocation(
          inventoryItem.area,
          inventoryItem.zone,
          null,
          null,
          null,
        );
      }
    } catch (err) {
      logError("LocationPicker:AislePicker:handleAisleChange", err, notify);
    }
  };

  const getAisleLabel = (area) => {
    if (isTrack(area)) return "Track";
    return "Aisle";
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <SelectInput
          source="aisleId"
          label={getAisleLabel(selectedArea)}
          variant="outlined"
          fullWidth
          allowEmpty={!required}
          choices={aisles}
          optionText="name"
          optionValue="id"
          disabled={disabled || aisles.length === 0}
          validate={required ? validateRequired : undefined}
          onChange={(e) => handleAisleChange(e.target.value)}
        />
      </Grid>
      {selectedAisle?.type === LocationType.UNSTRUCTURED && (
        <Grid item xs={12} sm={6}>
          <TextInput
            source="locationFullName"
            label="Location"
            variant="outlined"
            fullWidth
            disabled={true}
            format={(value) => {
              // STAFF LEVEL FIX: Ensure "T-1" format even if DB has raw "1"
              if (value && !value.includes("-") && !isNaN(value)) {
                return `T-${value}`;
              }
              return value || "Unspotted";
            }}
          />
        </Grid>
      )}
      {selectedAisle?.type === LocationType.UNSTRUCTURED && (
        <Grid item xs={12} style={{ textAlign: "right" }}>
          <ViewInventoryButton
            inventory={inventory}
            selectedLocation={selectedLocation}
            notify={notify}
            classes={classes}
          />
        </Grid>
      )}
    </Grid>
  );
};

const BulkSelector = ({
  classes,
  inventory,
  isMaxQuantity,
  inventoryItem,
  originalLocation,
  selectedLocation,
  handleLocation,
  bayList,
  locationInventoryItemMap,
  notify,
  ...props
}) => {
  const [utilizationQuantity, setUtilizationQuantity] = useState(
    getUtilizationQuantity(inventory),
  );
  const locationList = bayList[0]?.[0];

  const isLocationUsed = (location) => {
    return (
      locationInventoryItemMap[location.id] ||
      inventory.inventoryItems?.items?.some(
        (invItem) => invItem.locationId === location.id,
      )
    );
  };

  const handleShowQuantity = (value) => {
    // Switch between percentage and quantity
    localStorage.setItem("locationCapacityDisplay", value);
    setUtilizationQuantity(value);
  };

  const getLocationContent = (location) => {
    const capacityUsed = location.capacityUsed || 0;
    const capacityAllocated = location.capacityAllocated || 0;
    const locationCapacity = location.bulkCapacity || 0;
    let totalCapacityUsed = 0;

    if (locationCapacity > 0) {
      if (utilizationQuantity) {
        totalCapacityUsed =
          (capacityUsed + capacityAllocated).toLocaleString() +
          " / " +
          locationCapacity.toLocaleString() +
          " " +
          location.bulkUnits;
      } else {
        totalCapacityUsed =
          (
            ((capacityUsed + capacityAllocated) / locationCapacity) *
            100
          ).toLocaleString() + "%";
      }
    }

    return (
      <div>
        <Typography align="center" variant="body2">
          {getLocationViewName(location)}
        </Typography>
        <Typography align="center" variant="body2">
          {totalCapacityUsed}
        </Typography>
        <Typography align="center" variant="body2" noWrap>
          {location.accountName || <>&nbsp;</>}
        </Typography>
        <Typography align="center" variant="body2" noWrap>
          {location.productName || <>&nbsp;</>}
        </Typography>
      </div>
    );
  };

  const getAvatarClassName = (location) => {
    let returnClass;

    if (
      isBulkLocationAvailable(
        location,
        inventoryItem.inventory,
        inventoryItem.putawayQuantity,
        inventoryItem.isDamaged,
      )
    ) {
      returnClass = classes.locationAvatar;
    } else returnClass = classes.locationAvatarDisabled;

    if (location.id === selectedLocation?.id)
      returnClass = classes.locationAvatarSelected;
    else if (location.id === originalLocation?.id)
      returnClass = classes.locationAvatarOriginal;

    if (isLocationUsed(location)) {
      if (location.id === selectedLocation?.id)
        returnClass = classes.locationAvatarSelected;
      returnClass = clsx(returnClass, classes.locationAvatarAllocated);
    }

    return returnClass;
  };

  const handleLocationChange = (location) => {
    handleLocation(
      inventoryItem.area,
      inventoryItem.zone,
      inventoryItem.aisle,
      location,
      null,
    );
  };

  return (
    <Grid container spacing={1}>
      {showUtilizationQuantity(inventory) ? (
        <Grid item xs={12} sm={6}>
          <SwitchOnOff
            leftLabel="Percentage"
            rightLabel="Quantity"
            checked={utilizationQuantity}
            setChecked={handleShowQuantity}
            className={classes.switchInput}
          />
        </Grid>
      ) : (
        <Hidden xsDown>
          <Grid item xs={false} sm={6}></Grid>
        </Hidden>
      )}
      <Grid item xs={12} sm={6} style={{ textAlign: "right" }}>
        <ViewInventoryButton
          inventory={inventory}
          selectedLocation={selectedLocation}
          notify={notify}
          classes={classes}
        />
      </Grid>
      <Grid
        item
        xs={12}
        container
        spacing={1}
        className={classes.levelContainer}
      >
        {locationList &&
          locationList.map((location) => (
            <Grid item xs={12} sm={6} md={3}>
              <Box
                className={getAvatarClassName(location)}
                onClick={() => handleLocationChange(location)}
              >
                {getLocationContent(location)}
              </Box>
            </Grid>
          ))}
      </Grid>
    </Grid>
  );
};

const TrackDisplay = ({
  inventoryItem,
  outbound,
  selectedLocation,
  locationName,
  classes,
  ...props
}) => {
  const resolvedTrack = getTrackDisplaySelectedTrack({
    inventoryItem,
    outbound,
    selectedLocation,
  });
  const trackDisplayLocationName = getTrackDisplayLocationName({
    inventoryItem,
    outbound,
    selectedLocation,
    locationName,
  });

  if (outbound)
    return (
      <Grid container spacing={3}>
        <Grid item sm={false} md={4}>
          <fieldset style={{ height: "100%" }}>
            <legend>
              <Typography variant="overline" color="textSecondary">
                Outbound Inventory:
              </Typography>
            </legend>
            <Typography variant="body2" style={{ marginBottom: 8 }}>
              Location: {trackDisplayLocationName}
            </Typography>
            {outbound?.shipmentLineItems && (
              <ArrayField source="items" record={outbound.shipmentLineItems}>
                <Datagrid>
                  <FunctionField
                    source="status"
                    record={outbound}
                    render={(record) => OutboundStatusLabels[record.status]}
                  />
                  <NumberField source="totalQuantityToPick" label="Quantity" />
                  <FunctionField
                    source="totalUOM"
                    label="UOM"
                    render={() => outbound.totalUOM}
                  />
                </Datagrid>
              </ArrayField>
            )}
          </fieldset>
        </Grid>
        <Grid item sm={12} md={8}>
          <TrackLocationView
            inventoryItem={inventoryItem}
            selectedTrack={resolvedTrack}
            highlightShipmentId={outbound?.id}
          />
        </Grid>
      </Grid>
    );

  return (
    <Grid container spacing={3}>
      <Grid item sm={false} md={2}></Grid>
      <Grid item sm={12} md={8}>
        <Typography
          variant="body2"
          style={{ marginBottom: 8, textAlign: "center" }}
        >
          Location: {trackDisplayLocationName}
        </Typography>
        <TrackLocationView
          inventoryItem={inventoryItem}
          selectedTrack={resolvedTrack}
        />
      </Grid>
      <Grid item sm={false} md={2}></Grid>
    </Grid>
  );
};

const OutboundSelector = ({
  inventory,
  inventoryItem,
  selectedArea,
  selectedZone,
  aisles,
  selectedAisle,
  setSelectedAisle,
  selectedLocation,
  locationName,
  setLocationName,
  handleLocation,
  outbound,
  setOutbound,
  disabled,
  required,
  ...props
}) => {
  const notify = useNotify();
  const [outbounds, setOutbounds] = useState([]);
  const outboundChoices = outbounds.map((outbound) => ({
    id: outbound.id,
    displayName: getOutboundOptionText(outbound),
  }));

  useEffect(() => {
    selectedArea && getOutboundData();
  }, [selectedArea]);

  const getOutboundData = async () => {
    debugger;
    try {
      const searchInput = {
        filter: {
          carrierType: { eq: CarrierType.RAIL },
          // isCollected: {eq: false},
          // trackId: {gte: ""},
          status: { ne: OutboundStatus.RELEASED },
          // reloadYardCommodityId: {eq: inventory.reloadYardCommodityId},
        },
        limit: 1000,
      };
      const response = await API.graphql(
        graphqlOperation(searchOutboundShipments, searchInput),
      );
      const inventoryItems = inventory.inventoryItems?.items || [];

      const outboundsFiltered = getSelectableOutbounds({
        outbounds: response.data.searchOutboundShipments.items,
        inventoryItems,
        currentInventoryItemId: inventoryItem.id,
      });

      setOutbounds(outboundsFiltered);
    } catch (err) {
      logError("OutboundPicker:getOutboundData", err, notify);
    }
  };

  const handleOutboundSelect = async (outboundId) => {
    if (!outboundId) {
      setOutbound(null);
      setLocationName("");
      handleLocation(selectedArea, selectedZone, null, null, null);
      return;
    }

    const outboundCar = outbounds.find(
      (outboundShipment) => outboundShipment.id === outboundId,
    );
    if (!outboundCar) return;

    // Unspotted railcars cannot receive inventory — there is no track location
    // to assign to. Reject the selection and clear the field. (AutocompleteInput
    // has no per-option disable, so the block is enforced here on select.)
    if (isOutboundUnavailable(outboundCar)) {
      notify("Railcar is unspotted. Spot it on a track first.", "warning");
      setOutbound(null);
      setSelectedAisle(null);
      setLocationName("");
      handleLocation(selectedArea, selectedZone, null, null, null);
      return;
    }

    setOutbound(outboundCar);

    const outboundTrackId = getSelectedOutboundTrackId({
      outbounds,
      outboundId,
    });

    const response = await API.graphql(
      graphqlOperation(getLocation, { id: outboundTrackId }),
    );
    const location = response.data.getLocation;
    const aisle = location?.aisle;
    setSelectedAisle(aisle);
    const zone = aisle?.zone;
    setLocationName(getAisleFullName(aisle));
    handleLocation(inventoryItem.area, zone, aisle, location, outboundCar);
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <AutocompleteInput
          source="outboundShipmentId"
          label="Outbound railcar no."
          variant="outlined"
          fullWidth
          allowEmpty={!required}
          choices={outboundChoices}
          optionText="displayName"
          optionValue="id"
          disabled={disabled}
          validate={required ? validateRequired : undefined}
          onChange={(value) => handleOutboundSelect(value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextInput
          source="locationFullName"
          label="Track"
          variant="outlined"
          fullWidth
          disabled={true}
          format={(value) => {
            // STAFF LEVEL FIX: Ensure "T-1" format even if DB has raw "1"
            if (value && !value.includes("-") && !isNaN(value)) {
              return `T-${value}`;
            }
            return value || "Unspotted";
          }}
        />
      </Grid>
    </Grid>
  );
};

const showUtilizationQuantity = (inventory) => {
  // hide quantity switch & display for CONTAINER and if inventory is OTHER
  return (
    !isShippingContainer(inventory.reloadYardCommodity.commodity) &&
    inventory.reloadYardCommodity.commodity.locationLoadType !==
      LocationLoadType.OTHER
  );
};

const getUtilizationQuantity = (inventory) => {
  let value;
  if (!showUtilizationQuantity(inventory)) {
    value = false;
  } else {
    value = localStorage.getItem("locationCapacityDisplay");
    value = value !== null ? JSON.parse(value) : false;
  }
  return value;
};

const StructuredLocationSelector = ({
  classes,
  inventory,
  isMaxQuantity,
  inventoryItem,
  originalLocation,
  selectedLocation,
  handleLocation,
  bayList,
  locationInventoryItemMap,
  notify,
  ...props
}) => {
  const [utilizationQuantity, setUtilizationQuantity] = useState(
    getUtilizationQuantity(inventory),
  );
  const inventoryLoadType =
    inventory.reloadYardCommodity.commodity.locationLoadType;

  const isLocationUsed = (location) => {
    return (
      locationInventoryItemMap[location.id] ||
      inventory.inventoryItems?.items?.some(
        (invItem) => invItem.locationId === location.id,
      )
    );
  };

  const handleShowQuantity = (value) => {
    // Switch between percentage and quantity
    localStorage.setItem("locationCapacityDisplay", value);
    setUtilizationQuantity(value);
  };

  const getLocationContent = (location) => {
    const capacityUsed = location.capacityUsed || 0;
    const capacityAllocated = location.capacityAllocated || 0;
    let totalCapacityUsed = 0;

    if (utilizationQuantity) {
      const locationLoadType = location.locationLoad[inventoryLoadType];
      totalCapacityUsed =
        (capacityUsed + capacityAllocated) / locationLoadType.capacity;
    } else {
      totalCapacityUsed = capacityUsed + capacityAllocated + "%";
    }

    return (
      <div>
        <Typography align="center" variant="body2">
          {getLocationViewName(location)}
        </Typography>
        <Typography align="center" variant="body2">
          {totalCapacityUsed}
        </Typography>
      </div>
    );
  };

  const getAvatarClassName = (location) => {
    let returnClass;

    if (isLocationAvailable(bayList, location, inventoryItem.inventory)) {
      returnClass = classes.locationAvatar;
    } else returnClass = classes.locationAvatarDisabled;

    if (location.id === selectedLocation?.id)
      returnClass = classes.locationAvatarSelected;
    else if (location.id === originalLocation?.id)
      returnClass = classes.locationAvatarOriginal;

    if (isLocationUsed(location)) {
      if (location.id === selectedLocation?.id)
        returnClass = classes.locationAvatarSelected;
      returnClass = clsx(returnClass, classes.locationAvatarAllocated);
    }

    return returnClass;
  };

  const handleLocationChange = (location) => {
    handleLocation(
      inventoryItem.area,
      inventoryItem.zone,
      inventoryItem.aisle,
      location,
      null,
    );
  };

  return (
    <Grid container spacing={1}>
      {showUtilizationQuantity(inventory) ? (
        <Grid item xs={12} sm={6}>
          <SwitchOnOff
            leftLabel="Percentage"
            rightLabel="Quantity"
            checked={utilizationQuantity}
            setChecked={handleShowQuantity}
            className={classes.switchInput}
          />
        </Grid>
      ) : (
        <Hidden xsDown>
          <Grid item xs={false} sm={6}></Grid>
        </Hidden>
      )}
      <Grid item xs={12} sm={6} style={{ textAlign: "right" }}>
        <ViewInventoryButton
          inventory={inventory}
          selectedLocation={selectedLocation}
          notify={notify}
          classes={classes}
        />
      </Grid>
      {selectedLocation &&
        isCapacitySliderVisible(selectedLocation) &&
        inventory.status !== InventoryStatus.IN_TRANSIT &&
        inventory.status !== InventoryStatus.ARRIVED && (
          <Grid item xs={12}>
            <StructuredLocationCapacity
              location={selectedLocation}
              updateFn={handleLocationChange}
            />
          </Grid>
        )}
      <Grid item xs={12} className={classes.location}>
        {bayList.map((bay, bayIdx) => (
          <div key={`bay_${bayIdx}`} className={classes.bayContainer}>
            <div className={classes.item}>{bayIdx + 1}</div>
            <Divider className={classes.divider} />
            {bay.map((level, levelIdx) => (
              <div
                key={`bay_${bayIdx}_level_${levelIdx}`}
                className={classes.levelContainer}
              >
                {level.map((location) => {
                  return (
                    <div
                      key={location.id}
                      className={getAvatarClassName(location)}
                      onClick={() => handleLocationChange(location)}
                    >
                      {getLocationContent(location)}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        ))}
      </Grid>
    </Grid>
  );
};

const ViewInventoryButton = ({
  inventory,
  selectedLocation,
  notify,
  classes,
  ...props
}) => {
  const [showInventories, setShowInventories] = useState(false);

  return (
    <>
      <Button
        label="View Inventory"
        color="default"
        disabled={!selectedLocation}
        onClick={() => setShowInventories(true)}
      >
        <ShowIcon />
      </Button>
      {selectedLocation && showInventories && (
        <ViewInventoryDialog
          inventory={inventory}
          selectedLocation={selectedLocation}
          showInventories={showInventories}
          setShowInventories={setShowInventories}
          notify={notify}
          classes={classes}
        />
      )}
    </>
  );
};

const ViewInventoryDialog = ({
  inventory,
  selectedLocation,
  showInventories,
  setShowInventories,
  notify,
  classes,
  ...props
}) => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const [loading, setLoading] = useState(false);
  const [locationInventories, setLocationInventories] = useState([]);

  useEffect(() => {
    if (selectedLocation && showInventories) getInventories();
  }, [selectedLocation, showInventories]);

  const getInventories = async () => {
    try {
      debugger;
      setLoading(true);
      const promiseList = [
        API.graphql(
          graphqlOperation(inventoryItemByLocationByStatus, {
            locationId: selectedLocation.id,
            status: { beginsWith: InventoryStatus.IN_TRANSIT },
          }),
        ),
        API.graphql(
          graphqlOperation(inventoryItemByLocationByStatus, {
            locationId: selectedLocation.id,
            status: { beginsWith: InventoryStatus.UNLOADED },
          }),
        ),
        API.graphql(
          graphqlOperation(inventoryItemByLocationByStatus, {
            locationId: selectedLocation.id,
            status: { beginsWith: InventoryStatus.REVIEW },
          }),
        ),
        API.graphql(
          graphqlOperation(inventoryItemByLocationByStatus, {
            locationId: selectedLocation.id,
            status: { beginsWith: InventoryStatus.STORED },
          }),
        ),
      ];
      const results = await Promise.all(promiseList);
      let inventoryItemsList = [
        ...results[0].data.inventoryItemByLocationByStatus.items,
        ...results[1].data.inventoryItemByLocationByStatus.items,
        ...results[2].data.inventoryItemByLocationByStatus.items,
        ...results[3].data.inventoryItemByLocationByStatus.items,
      ];

      if (inventoryItemsList.length > 0) {
        inventoryItemsList.sort((a, b) => {
          // First, sort by accountName
          const accountComparison = a.inventory.accountName.localeCompare(
            b.inventory.accountName,
          );
          if (accountComparison !== 0) return accountComparison;

          // If accountName is the same, sort by productName
          const productComparison = a.inventory.productName.localeCompare(
            b.inventory.productName,
          );
          if (productComparison !== 0) return productComparison;

          // If both accountName and productName are the same, sort by quantityOnHand
          return b.quantityOnHand - a.quantityOnHand;
        });
      }
      setLocationInventories({ items: inventoryItemsList });
    } catch (error) {
      logError(
        "LocationPicker:ViewInventoryDialog:getInventories",
        error,
        notify,
      );
    } finally {
      setLoading(false);
    }
  };

  const CombinedFlag = ({ record }) => {
    return (
      <>
        {record.inboundShipmentId === inventory.inboundShipmentId ? (
          <Tooltip title="In current shipment" placement="right" arrow>
            <CheckIcon
              style={{ marginRight: "16px", color: green[500] }}
              fontSize="medium"
            />
          </Tooltip>
        ) : (
          <Tooltip title="In other shipment" placement="right" arrow>
            <CloseIcon
              style={{ marginRight: "16px", color: deepOrange[500] }}
              fontSize="medium"
            />
          </Tooltip>
        )}
        <InventoryStatusIcon inventory={record.inventory} placement="right" />
      </>
    );
  };

  return (
    <Dialog
      open={showInventories}
      onClose={() => setShowInventories(false)}
      fullWidth
      fullScreen={isSmall}
      maxWidth="lg"
    >
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Typography variant="h6">
          {`${getLocationFullName(selectedLocation)} inventories`}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => setShowInventories(false)}
        >
          <CloseIcon fontSize="large" />
        </IconButton>
      </DialogTitle>
      {loading ? (
        <DialogContent>
          <Loading />
        </DialogContent>
      ) : (
        <DialogContent>
          {
            <ArrayField source="items" record={locationInventories}>
              <Datagrid>
                <CombinedFlag label="" />
                <TextField
                  source="inventory.productName"
                  label="Product Name"
                />
                <TextField source="inventory.accountName" label="Account" />
                <TextField source="inventory.lotNumber" label="Lot No." />
                <NumberField source="quantityOnHand" label="Quantity" />
                <TextField source="inventory.inventoryUOM" label="UOM" />
              </Datagrid>
            </ArrayField>
          }
          {/* {
                    showTotalQuantity &&
                    <Box mt={1}>
                        {`Total quantity: ${totalQuantity} ${loadTypeName}`}
                    </Box>
                } */}
        </DialogContent>
      )}
      <DialogActions>
        <Button
          label="Close"
          color="defalut"
          autoFocus
          onClick={() => setShowInventories(false)}
        >
          <CancelIcon />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
